import axios from 'axios';

export const SESSION_REPLACED_MESSAGE =
  'Tu sesión fue cerrada porque se inició sesión en otro dispositivo.';

const clearStoredSession = (message = null) => {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  if (message) localStorage.setItem('auth_notice', message);
  delete api.defaults.headers.common['Authorization'];
};

const isSessionReplaced = (error) =>
  error?.response?.headers?.['x-auth-error'] === 'session_replaced' ||
  error?.response?.data?.detail === SESSION_REPLACED_MESSAGE;

const redirectToLogin = () => {
  if (window.location.pathname !== '/login') window.location.assign('/login');
};

// Asegurar que la URL siempre termine con /api/v1
export const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  // Si no termina con /api/v1, agregarlo
  if (!envUrl.endsWith('/api/v1')) {
    return envUrl.endsWith('/') ? `${envUrl}api/v1` : `${envUrl}/api/v1`;
  }
  return envUrl;
};

const api = axios.create({
  baseURL: getApiUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000, // 30 segundos de timeout (aumentado para evitar timeouts)
});

// Interceptor para agregar token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      if (isSessionReplaced(error)) {
        clearStoredSession(SESSION_REPLACED_MESSAGE);
        redirectToLogin();
        return Promise.reject(error);
      }

      const originalRequest = error.config || {};
      const requestUrl = String(originalRequest.url || '');
      if (
        originalRequest._retry ||
        requestUrl.includes('/auth/login') ||
        requestUrl.includes('/auth/refresh')
      ) {
        return Promise.reject(error);
      }

      // Token expirado, intentar refresh
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        originalRequest._retry = true;
        try {
          const response = await axios.post(
            `${getApiUrl()}/auth/refresh`,
            { refresh_token: refreshToken }
          );
          const newToken = response.data.access_token;
          localStorage.setItem('token', newToken);
          api.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api.request(originalRequest);
        } catch (refreshError) {
          clearStoredSession(
            isSessionReplaced(refreshError) ? SESSION_REPLACED_MESSAGE : null
          );
          redirectToLogin();
        }
      } else {
        clearStoredSession();
        redirectToLogin();
      }
    }
    return Promise.reject(error);
  }
);

export default api;

